export const OutStateModel = {
    path: '/out_state_models',
    name: 'out_state_models',
    component: () => import('@/views/OutStateModel/OutStateModelPage.vue'),
    children: [
        {
            path: '/out_state_models/add',
            name: 'out_state_models.add',
            component: () => import('@/views/OutStateModel/Form/OutStateModelForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/out_state_models/edit/:id',
            name: 'out_state_models.edit',
            component: () => import('@/views/OutStateModel/Form/OutStateModelForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/out_state_models/delete/:id',
            name: 'out_state_models.delete',
            component: () => import('@/views/OutStateModel/Form/OutStateModelForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/out_state_models/view/:id',
            name: 'out_state_models.view',
            component: () => import('@/views/OutStateModel/Form/OutStateModelForm.vue'),
            props: {viewAction: true}
        },
    ],
}